export function convertAmountToCents(amount: number) {
    return Math.round(amount * 100);
}

export function convertAmountToBaseUnits(amount: number) {
    return amount / 100;
}
